import React from "react";



import StockList from "./StockList";

import './portfolio.css';



  
const Porfolios = () => {
  

  return (
    <div className="content" align="left">
        <h2 className="title" > Portfolios</h2>
        <div> Smart stragies are designed to construct model protfolios using algoritmic rules that match a specific investment style. Our research selects strategies by leveraging our model's rankings to generate positve alpha. Strategies are constructed combining qulaity factors with a criteria rank that is unique and optimat for it's objective. For example our Momentum strategy is ranked based on our AI predictions for Momentum, while our Growth strategy will consider Valuation and Sentiment scores above a certain threshold to improve outcomes. We occasionally run optimization algorithms to tune the setting of each stratgy, while maintaning the rules that are consideres at the core of each of our long-term strategies.</div>
        <div className="col-lg-11 col-sm-11 col-xs-11">
        <div className="title">
            <h3 className="blue" > US Total Market Growth Strategy </h3>
            </div>
            <div className="text"> The Growth Quants strategy seeks higher rates of returns on equity investments in global companies that have good growth potential. The portfolio selection is optimized for highest short-term rate of success by applying fundamental analysis of quantitative multi-facore objective pertaining to growth, valuation and profitability over the past and the mid-term outlook.  <h5><a href="/growth.html">Stats and more ...</a></h5></div>
            <h4 className="blue" > Recommendations </h4>
            <StockList strategy="growth" />
        </div>

        <div className="col-lg-11 col-sm-11 col-xs-11">
        <div className="title">
            <h3 className="blue" > US Total Market Value Strategy</h3>
            </div>
            <div className="text"> The Value Quants strategy seeks higher rate of returns on equity investments in global companies that present a value opportunity. The portfolio selection is optimized for the short-term highest rate of success at the lowest possible risk by applying fundamental analysis of quantitative objective factors pertaining to valuation, financial stength and profitability over the past year and the near future. <h5><a href="/momentum.html"> Stats and more ...</a></h5> </div>  
            <h4 className="blue" > Recommendations </h4>
            <StockList strategy="value" />
        </div>

        <div className="col-lg-11 col-sm-11 col-xs-11">
            <div className="title">
            <h3 className="blue" > US Momentum AI Strategy</h3>
            </div>
            <div className="text">The Momentum AI strategy seeks higher rate of returns on equity investments in global companies that present a short-term opportunity. The portfolio selection is based on a machine learning algorithm that picks stocks with the highest potential for short-term gains. It works by applying ML analysis on the past and the near-term price action. <h5><a href="/momentum.html">Stats and more ...</a></h5> </div>
            <h4 className="blue" > Recommendations </h4>
            <StockList strategy="momentum" />
        </div>

        <div className="col-lg-11 col-sm-11 col-xs-11">
            <div className="title">
            <h3 className="blue" > US Qualty Strategy</h3>
            </div>
            <div className="text">The US Quality selection seeks higher rate of returns on equity investments in US companies that present a favorable ranking in all factors. The portfolio selection is based on a combination of quatitative and technical analysis with AI predictions for stocks with the highest potential for short-term gains.  <h5><a href="/quality.html">Stats and more ...</a></h5> </div>
            <h4 className="blue" > Recommendations </h4>
            <StockList strategy="quality" />
        </div>

        <div className="col-lg-11 col-sm-11 col-xs-11">
            <div className="title">
            <h3 className="blue" > US Sector Leaders </h3>
            </div>
            <div className="text">The US Secotr Leader is an investments in top ranking US companies that present a favorable ranking  compared to all the others. The portfolio selection is based on a combination of quatitative fundamental and technical analysis with AI predictions for stocks with the highest potential for short-term gains.  <h5><a href="/quality.html">Stats and more ...</a></h5> </div>
            <h4 className="blue" > Recommendations </h4>
            <StockList strategy="leaders" />
        </div>

    </div>
  );
};
  
export default Porfolios;

/* the simple way             
<div className="links">    
        <a href="/growth-quants.html">Growth Quants</a>
        <a href="/value-quants.html">Value Quant</a>
        <a href="/momentum-ai.html">Momentum Ai</a>
</div>
*/
/* nav links to sub components 
import { Nav, NavLink, NavMenu } 
    from "./NavbarElements";
<>
<Nav>
  <NavMenu>
    <NavLink to="/Growth" activeStyle>
      Growth Protfolio
    </NavLink>
    <NavLink to="/Value" activeStyle>
      Value Portfolio
    </NavLink>
    <NavLink to="/Momentum" activeStyle>
      Momentum Ai Porftolio
    </NavLink>
  </NavMenu>
</Nav>
</>
*/